import { ProgressBarBase, ProgressBarSkeleton } from './progress-bar.shared';
import type { ProgressBarProps } from './types';

export function ProgressBar(props: ProgressBarProps) {
  return <ProgressBarBase {...props} accent={{ fill: 'bg-green-500', active: 'bg-green-300' }} />;
}

ProgressBar.Skeleton = ProgressBarSkeleton;
